import React from 'react'

import CreditCardTemplate from './CreditCard'

export default React.createClass({
    render(){
        return (
            <div class="row">
                <CreditCardTemplate cardId={this.props.routeParams.id}/>
            </div>
        )
    }
});


// WEBPACK FOOTER //
// app/views/CreditCard/index.js